// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ynau","questions":"styles_questions__2hZ2Q","footer":"styles_footer__3_OHJ"};